import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/app/[locale]/error.tsx");
